import { connect } from '../../react-redux';
import RceConfigProviderComponent from './presenter';
import { getRCEConfig } from '../../selectors/rce';
import { getActiveQuiz } from '../../selectors/quizzes';
import { setStoredRCEConfig } from '../../actions/rce';
import { featureOn } from '../../util/featureCheck';
var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    storedRCEConfig: getRCEConfig(state),
    displayOldLinks: featureOn('instfs_display_old_links_rollback'),
    activeQuiz: getActiveQuiz(state)
  };
};
var mapDispatchToProps = {
  setStoredRCEConfig: setStoredRCEConfig
};
var RceConfigProvider = connect(mapStateToProps, mapDispatchToProps)(RceConfigProviderComponent);
export default RceConfigProvider;